import Loader from "components/elements/Loader/Loader";
import {
  ChangeEventHandler,
  FormEventHandler,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import { apiRequest, getUser, setOnboarding } from "utils/service";

const SelectGroup = () => {
  const user = useMemo(() => getUser(), []);
  const [, forceUpdate] = useState("");
  const [groupTypes, setGroupTypes] = useState<
    { group_id: string; group_name: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    group_id: "",
  });
  const validator = useMemo(
    () =>
      new SimpleReactValidator({
        autoForceUpdate: { forceUpdate },
      }),
    [forceUpdate]
  );

  const handleFormSubmit: FormEventHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      setLoading(true);
      apiRequest("group_type_submit", formData)
        .then((resp) => {
          if (resp.success === "true") {
            toast.success(resp.message);
            const updatedOnboardingData = {
              path: "select-subject",
              group_id: formData.group_id,
            };
            setOnboarding(updatedOnboardingData);
            window.location.href = updatedOnboardingData.path;
          } else {
            toast.error(resp.message);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      validator.showMessages();
    }
  };

  const getGroupTypes = useCallback(() => {
    apiRequest("group_type", { exam_type_id: user.exam_type_id }, "get").then(
      (resp) => {
        if (resp.success === "true") {
          setGroupTypes(resp.data);
        }
      }
    );
  }, [setGroupTypes, user]);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getGroupTypes();
  }, [getGroupTypes]);

  const instruction = `1. Any One Subject Subsciption is Free for 2 Days.<br />

  Select any One Subject from:<br />

  CA Inter: Advanced A/c, AS Advanced A/c, Costing, FM & SM<br />

  CA Final: FR, SFM Audit & Direct Tax<br />

2. Appearing Single Group 1 - Select Option from Group 1 only.<br />

3. Appearing Single Group 2 - Select Option from Group 2 only.<br />

4. Appearing for Both Groups 1 & 2 - Select Option from Group 1 & 2 only.<br />

For Paid Subscription - After Login Please Select Profile & Subscription.<br />

Contact: 9870942020 / 9821342020`;

  return (
    <div className="login-container">
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card">
          <div className="card-header">
            <h3>Select Group</h3>
          </div>
          <div className="card-body">
            <form
              onSubmit={handleFormSubmit}
              className="d-flex flex-column gap-2"
            >
              <div className="row">
                <div className="col-8 offset-2 ">
                  {groupTypes.map(({ group_name, group_id }) => (
                    <div className="w-100" key={group_id}>
                      <div className="form-check d-flex justify-content-start flex-column">
                        <div className="d-flex text-start">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="group_id"
                            value={group_id}
                            id={`exam_radio_${group_id}`}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label text-white ms-2"
                            htmlFor={`exam_radio_${group_id}`}
                          >
                            {group_name}
                          </label>
                        </div>
                        <div className="d-flex">
                          {validator.message("group", formData.group_id, "required", {
                            className: "text-danger",
                          })}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <input
                  disabled={loading}
                  type="submit"
                  value="Submit"
                  className="btn float-right login_btn mt-4"
                />
              </div>
              <div className="form-group text-start mt-2">
                <h6 className="text-white">Please Read Carefully Before Registration:</h6>
                <small className="text-white" dangerouslySetInnerHTML={{ __html: instruction }}>
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectGroup;
